export enum BetslipPickChangeType {
    OddsChange,
    VisibilityChange,
    LockChange,
}

export interface BetslipPickChangeInfo {
    changeType?: BetslipPickChangeType;
}
